import React, { ReactElement, ReactNode } from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import classnames from 'classnames';

interface Props<T> {
  name: keyof T;
  className?: string;
  children?: ReactNode;
  as?: keyof JSX.IntrinsicElements;
}

/**
 * Combines rds-Formfield with Formik Field behavior.
 * This must be used within a Formik context (Formik component or withFormik()).
 * @returns {ReactElement} FormikFormMultiField
 */
function FormikFormMultiField<T = unknown>({
  as = 'div',
  name,
  className = '',
  children,
}: Props<T>): ReactElement {
  const { errors, touched } = useFormikContext<T>();
  const TagName = as;

  return (
    <TagName
      className={classnames('rds-FormField', `${className}`, {
        'is-invalid': errors[name] && touched[name],
      })}
    >
      {children}
      <ErrorMessage
        name={name.toString()}
        component="p"
        className="rds-FormField-error"
        data-testid={`${name.toString()}Error`}
      />
    </TagName>
  );
}

export { FormikFormMultiField };
